import React from 'react';
import {
  ShoppingCart,
  Plus,
  Trash2,
  X,
  Loader2,
  Scale,
  Edit3
} from 'lucide-react';

const PDVWeightModal = ({
  setShowWeightModal,
  loadingWeightItems,
  showNewWeightItemForm,
  setShowNewWeightItemForm,
  setEditingWeightItem,
  editingWeightItem,
  newWeightItemName,
  setNewWeightItemName,
  newWeightItemPrice,
  setNewWeightItemPrice,
  updateWeightItem,
  createWeightItem,
  weightItems,
  selectedWeightItem,
  setSelectedWeightItem,
  weightInGrams,
  setWeightInGrams,
  startEditWeightItem,
  deleteWeightItem,
  calculateWeightTotal,
  addWeightItemToCart
}) => {
  return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[1000001] flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl w-full max-w-lg max-h-[90vh] overflow-hidden shadow-2xl flex flex-col">
            {/* Header do Modal */}
            <div className="bg-gradient-to-r from-emerald-500 to-teal-600 px-6 py-4 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
                  <Scale className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h2 className="text-white font-bold text-xl">Venda por Peso</h2>
                  <p className="text-emerald-100 text-sm">Selecione o item e informe o peso</p>
                </div>
              </div>
              <button
                onClick={() => setShowWeightModal(false)}
                className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all"
                data-testid="close-weight-modal"
              >
                <X className="w-5 h-5 text-white" />
              </button>
            </div>

            {/* Corpo do Modal */}
            <div className="flex-1 overflow-y-auto p-4 space-y-4">
              {loadingWeightItems ? (
                <div className="flex flex-col items-center justify-center py-12">
                  <Loader2 className="w-10 h-10 text-emerald-500 animate-spin mb-3" />
                  <p className="text-slate-500 font-medium">Carregando itens...</p>
                </div>
              ) : (
                <>
                  {/* Lista de Itens Cadastrados */}
                  <div className="bg-slate-50 rounded-2xl p-4">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="font-bold text-slate-800">Itens Cadastrados</h3>
                      <button
                        onClick={() => {
                          setShowNewWeightItemForm(!showNewWeightItemForm);
                          setEditingWeightItem(null);
                          setNewWeightItemName('');
                          setNewWeightItemPrice('');
                        }}
                        className="text-emerald-600 hover:text-emerald-700 text-sm font-medium flex items-center gap-1"
                      >
                        <Plus className="w-4 h-4" />
                        Novo Item
                      </button>
                    </div>

                    {/* Formulário de Novo Item / Edição */}
                    {showNewWeightItemForm && (
                      <div className="bg-white rounded-xl p-3 mb-3 border-2 border-emerald-200">
                        <div className="flex flex-col sm:flex-row gap-2 mb-2">
                          <input
                            type="text"
                            placeholder="Nome do item"
                            value={newWeightItemName}
                            onChange={(e) => setNewWeightItemName(e.target.value)}
                            className="flex-1 px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                          />
                          <div className="relative">
                            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm">R$</span>
                            <input
                              type="number"
                              placeholder="0,00"
                              value={newWeightItemPrice}
                              onChange={(e) => setNewWeightItemPrice(e.target.value)}
                              step="0.01"
                              min="0"
                              className="w-full sm:w-28 pl-9 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                            />
                          </div>
                        </div>
                        <div className="flex gap-2">
                          <button
                            onClick={editingWeightItem ? updateWeightItem : createWeightItem}
                            className="flex-1 px-3 py-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg text-sm font-medium transition-all"
                          >
                            {editingWeightItem ? 'Salvar' : 'Criar Item'}
                          </button>
                          <button
                            onClick={() => {
                              setShowNewWeightItemForm(false);
                              setEditingWeightItem(null);
                              setNewWeightItemName('');
                              setNewWeightItemPrice('');
                            }}
                            className="px-3 py-2 bg-slate-200 hover:bg-slate-300 text-slate-600 rounded-lg text-sm font-medium transition-all"
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    )}

                    {/* Lista de Itens */}
                    {weightItems.length === 0 ? (
                      <div className="text-center py-6 text-slate-400">
                        <Scale className="w-10 h-10 mx-auto mb-2 opacity-50" />
                        <p className="text-sm">Nenhum item cadastrado</p>
                        <p className="text-xs">Clique em &quot;Novo Item&quot; para adicionar</p>
                      </div>
                    ) : (
                      <div className="space-y-2">
                        {weightItems.map(item => (
                          <div
                            key={item.id}
                            onClick={() => {
                              setSelectedWeightItem(item);
                              setWeightInGrams('');
                            }}
                            className={`flex items-center justify-between p-3 rounded-xl cursor-pointer transition-all ${
                              selectedWeightItem?.id === item.id
                                ? 'bg-emerald-100 border-2 border-emerald-500 shadow-md'
                                : 'bg-white border-2 border-slate-200 hover:border-emerald-300'
                            }`}
                          >
                            <div className="flex-1">
                              <p className={`font-medium ${selectedWeightItem?.id === item.id ? 'text-emerald-700' : 'text-slate-700'}`}>
                                {item.name}
                              </p>
                              <p className={`text-sm ${selectedWeightItem?.id === item.id ? 'text-emerald-600' : 'text-slate-500'}`}>
                                R$ {item.price_per_kg.toFixed(2)}/kg
                              </p>
                            </div>
                            <div className="flex items-center gap-1">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  startEditWeightItem(item);
                                }}
                                className="p-2 text-slate-400 hover:text-emerald-600 hover:bg-emerald-50 rounded-lg transition-all"
                              >
                                <Edit3 className="w-4 h-4" />
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  deleteWeightItem(item.id);
                                }}
                                className="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all"
                              >
                                <Trash2 className="w-4 h-4" />
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Seção de Informar Peso (aparece ao selecionar item) */}
                  {selectedWeightItem && (
                    <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-4 border-2 border-emerald-200">
                      <h3 className="font-bold text-emerald-800 mb-3 flex items-center gap-2">
                        <Scale className="w-5 h-5" />
                        INFORMAR PESO
                      </h3>
                      
                      {/* Item Selecionado */}
                      <div className="bg-white rounded-xl p-3 mb-4">
                        <p className="font-semibold text-slate-800">{selectedWeightItem.name}</p>
                        <p className="text-emerald-600 text-sm font-medium">
                          R$ {selectedWeightItem.price_per_kg.toFixed(2)} por kg
                        </p>
                      </div>

                      {/* Input de Peso */}
                      <div className="mb-4">
                        <label className="block text-sm font-medium text-slate-600 mb-2">Peso em gramas:</label>
                        <div className="relative">
                          <input
                            type="number"
                            placeholder="Ex: 500"
                            value={weightInGrams}
                            onChange={(e) => setWeightInGrams(e.target.value)}
                            min="1"
                            step="1"
                            className="w-full px-4 py-3 bg-white border-2 border-slate-200 rounded-xl text-lg font-medium focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                          />
                          <span className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 font-medium">g</span>
                        </div>
                      </div>

                      {/* Presets de Peso */}
                      <div className="mb-4">
                        <label className="block text-sm font-medium text-slate-600 mb-2">Pesos rápidos:</label>
                        <div className="flex flex-wrap gap-2">
                          {[100, 250, 500, 750, 1000].map(grams => (
                            <button
                              key={grams}
                              onClick={() => setWeightInGrams(grams.toString())}
                              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                                weightInGrams === grams.toString()
                                  ? 'bg-emerald-500 text-white shadow-lg shadow-emerald-500/30'
                                  : 'bg-white text-slate-600 border-2 border-slate-200 hover:border-emerald-300'
                              }`}
                            >
                              {grams >= 1000 ? `${grams / 1000}kg` : `${grams}g`}
                            </button>
                          ))}
                        </div>
                      </div>

                      {/* Card de Total */}
                      {weightInGrams && parseFloat(weightInGrams) > 0 && (
                        <div className="bg-gradient-to-r from-emerald-500 to-teal-500 rounded-xl p-4 text-white">
                          <div className="flex items-center justify-between">
                            <div>
                              <p className="text-emerald-100 text-sm">Total calculado:</p>
                              <p className="text-sm text-emerald-100">
                                {parseFloat(weightInGrams) >= 1000 
                                  ? `${(parseFloat(weightInGrams) / 1000).toFixed(2).replace('.', ',')}kg` 
                                  : `${weightInGrams}g`
                                } × R$ {selectedWeightItem.price_per_kg.toFixed(2)}/kg
                              </p>
                            </div>
                            <div className="text-right">
                              <p className="text-3xl font-bold">
                                R$ {calculateWeightTotal.toFixed(2)}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Footer do Modal */}
            <div className="border-t border-slate-200 p-4 bg-white">
              <button
                onClick={addWeightItemToCart}
                disabled={!selectedWeightItem || !weightInGrams || calculateWeightTotal <= 0}
                className={`w-full py-4 rounded-2xl font-bold text-lg transition-all flex items-center justify-center gap-3 ${
                  selectedWeightItem && weightInGrams && calculateWeightTotal > 0
                    ? 'bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white shadow-lg shadow-emerald-500/30'
                    : 'bg-slate-200 text-slate-400 cursor-not-allowed'
                }`}
              >
                <ShoppingCart className="w-5 h-5" />
                <span>
                  {calculateWeightTotal > 0 
                    ? `Adicionar ao carrinho • R$ ${calculateWeightTotal.toFixed(2)}`
                    : 'Selecione um item e informe o peso'
                  }
                </span>
              </button>
            </div>
          </div>
        </div>
  );
};

export default PDVWeightModal;
